import { isNull, get } from "lodash"
import locales from "./../../../content.json"

export const checkIsValidFitnesLevel = data => {
    return validateFitnesLevelStep(get(data, ["fitnesLevel", "value"], "")) && !data.fitnesLevel.isValid
}

export const validateFitnesLevelStep = value => {
    return !isNull(value)
}

export const fitnesLevelData = {
    beginner: {
        value:"beginner",
        title: "Beginner",
        title: locales[window.userLang].beginner,
    },
    intermediate: {
        value:"intermediate",
        title: "Intermediate",
        title: locales[window.userLang].intermediate,
    },
    advanced: {
        value:"advanced",
        title: "Advanced",
        title: locales[window.userLang].advanced,
    },
}

export const defaultFasting = false